import React from 'react'
import { func, number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useContainerWidth, Separator, IconButton } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'

const centeredContentStyle = css`
  display: flex;
  height: auto;
  align-items: center;
  justify-content: center;
`

const templeTitleStyle = css`
  color: #88ddf8;
  font-family: museo, Verdana;
  font-size: clamp(1.1rem, 1.2vw, 1.5rem);
  margin: 10px 0;
`

const dedicationStyle = css`
  padding-bottom: 20px;
  font-size: clamp(0.9rem, 0.8vw, 1rem);
`

export default function TempleInfo({ info, moveLeft, moveRight, numTemples }) {
  const atWidth = useContainerWidth()
  const [title, additionalText] = info ? info.body : ['', '']

  const templeImageStyle = css`
    max-width: 90%;
  `
  return info && info.length !== 0 ? (
    <>
      <div css={centeredContentStyle}>
        {numTemples > 1 && (
          <IconButton
            data-testid="temple-info-temple-icon-button"
            Icon={ArrowCaret}
            size={atWidth({ default: 'sm', md: 'md' })}
            iconDirection="backward"
            onClick={moveLeft}
            onKeyDown={moveLeft}
          />
        )}
        <img css={templeImageStyle} src={info.imageURL} alt="Temple" />
        {numTemples > 1 && (
          <IconButton
            data-testid="temple-info-arrow-caret-icon-button"
            Icon={ArrowCaret}
            size={atWidth({ default: 'sm', md: 'md' })}
            onClick={moveRight}
            onKeyDown={moveRight}
          />
        )}
      </div>
      <div css={templeTitleStyle}>{title}</div>
      <Separator size="sm" />
      <div css={dedicationStyle}>{additionalText}</div>
    </>
  ) : null
}

TempleInfo.propTypes = {
  info: shape({
    categoryId: number,
    endYear: number,
    icon: string,
    id: string,
    imageURL: string,
    languageOnly: string,
    localeOnly: string,
    startYear: number,
    subcategory: string,
    textAdditional: string,
    textHeadline: string,
    textTitle: string,
    tileType: string,
    year: number,
  }),
  moveLeft: func,
  moveRight: func,
}
